import { CookieCategory } from './types';

/**
 * Versione della cookie policy. Incrementare quando cambiano finalità o
 * terze parti: invalida i consensi raccolti e ri-presenta il banner.
 * Allineata alla revisione della pagina /cookie-policy.
 */
export const CURRENT_COOKIE_POLICY_VERSION = '2026-06';

/** Chiave localStorage — segue la convenzione klaro7_* del progetto. */
export const COOKIE_CONSENT_STORAGE_KEY = 'klaro7_cookie_consent';

/** Schema interno dell'envelope di storage (distinto dalla versione policy). */
export const COOKIE_CONSENT_STORAGE_SCHEMA = 1;

/** Re-prompt dopo 6 mesi (regola Garante). ~182 giorni. */
export const COOKIE_CONSENT_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 182;

/** Evento globale emesso a ogni variazione di consenso (per gli script-loader). */
export const COOKIE_CONSENT_EVENT = 'klaro7:consent-changed';

/** Default: necessari ON (locked), analitici anonimizzati ON, profilazione OFF. */
export const DEFAULT_CATEGORIES = {
  [CookieCategory.NECESSARY]: true,
  [CookieCategory.ANALYTICS]: true,
  [CookieCategory.PROFILING]: false,
} as const;

export interface CategoryMeta {
  category: CookieCategory;
  title: string;
  description: string;
  locked?: boolean;
}

/** Metadati e copy (IT) delle categorie mostrate nel pannello preferenze. */
export const CATEGORY_META: CategoryMeta[] = [
  {
    category: CookieCategory.NECESSARY,
    title: 'Cookie tecnici e necessari',
    description:
      "Indispensabili per la navigazione, l'autenticazione e le funzioni di base del sito. Non possono essere disattivati.",
    locked: true,
  },
  {
    category: CookieCategory.ANALYTICS,
    title: 'Cookie analitici anonimizzati',
    description:
      'Ci aiutano a capire come viene utilizzato il sito tramite dati aggregati e anonimi. Non identificano i singoli utenti.',
  },
  {
    category: CookieCategory.PROFILING,
    title: 'Cookie di profilazione',
    description:
      'Utilizzati per mostrarti contenuti e comunicazioni in linea con i tuoi interessi. Attivi solo con il tuo consenso esplicito.',
  },
];
